export default {
  Created: 0,
  Pending: 1,
  Completed: 2,
  Expired: 3,
  Failed: 4,
  NeedsReview: 5,
  Approved: 6,
  Declined: 7
}

export const KYCInquiryType = {
  Master: 0,
  Supplementary: 1
}
